export default "__VITE_ASSET__Bh$7a7WW__"